import styled from 'styled-components';

export const Meta = {
  Container: styled.div`
    display: flex;
    justify-content: space-between;
  `,
  TypeText: styled.div`
    display: -webkit-box;
    webkit-line-clamp: 3;
    webkit-box-orient: vertical;
    overflow: hidden;
    min-width: 75px;
  `,
  Price: styled.div`
    margin-left: 12px;
    white-space: nowrap;
    display: flex;
    align-items: center;
  `,
  StatusCircleIcon: styled.div<{ $allPricesPresent: boolean | null }>`
    width: 10px;
    height: 10px;
    margin-left: 8px;
    border-radius: 50%;
    background: ${({ $allPricesPresent }) => {
      if ($allPricesPresent === false) {
        return '#FFD666';
      }

      if ($allPricesPresent === null) {
        return '#F5222D';
      }

      return '#52C41A';
    }};
  `,
};
